module.exports = __webpack_public_path__ + "img/riskmanagement-graph2-ar.63f3df34.png";